import Request from "../request";
const request = new Request();

export class SignupService {
  static list = async (startDate: any, endDate: any, group: any, limit: any, offset: any) => {
    const res = await request.get(
      "admin/sign/list?" +
        `startDate=${startDate}&endDate=${endDate}&group=${group}&limit=${limit}&offset=${offset}`
    );
    return res.data;
  };

  static async getStatData() {
    const { data } = await request.get("users/stat");

    return data.data;
  }
}
